import { useState, useEffect } from 'react';
import type { LoadableResult } from '../models';

export function useOnMount<T>(
  promise: Promise<T>,
  initialResult: T
): LoadableResult<T> {
  const [response, setResponse] = useState<LoadableResult<T>>({
    loaded: false,
    result: initialResult,
  });

  useEffect(() => {
    (async () => {
      const result = await promise;
      setResponse({ loaded: true, result });
    })();
  }, [promise]);

  return response;
}
